import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const CheckoutSuccess = ({ onClearCart }) => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [status, setStatus] = useState('checking');
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) {
      setStatus('error');
      return;
    }

    const checkPaymentStatus = async () => {
      try {
        const response = await axios.get(`${API}/checkout/status/${sessionId}`);
        
        if (response.data.payment_status === 'paid') {
          setStatus('success');
          onClearCart();
        } else if (response.data.status === 'expired') {
          setStatus('expired');
        } else if (attempts < 5) {
          setTimeout(() => {
            setAttempts(attempts + 1);
          }, 2000);
        } else {
          setStatus('timeout');
        }
      } catch (error) {
        console.error('Error checking payment status:', error);
        if (attempts < 5) {
          setTimeout(() => {
            setAttempts(attempts + 1);
          }, 2000);
        } else {
          setStatus('error');
        }
      }
    };

    checkPaymentStatus();
  }, [sessionId, attempts, onClearCart]);

  if (status === 'checking') {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center" data-testid="payment-checking">
          <Loader2 className="w-16 h-16 text-primary animate-spin mx-auto mb-4" />
          <h2 className="font-heading font-semibold text-2xl mb-2">Vérification du paiement...</h2>
          <p className="text-muted-foreground">Veuillez patienter</p>
        </div>
      </div>
    );
  }

  if (status === 'success') {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="max-w-md mx-auto px-4 text-center" data-testid="payment-success">
          <div className="bg-white rounded-xl p-12">
            <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="w-12 h-12 text-primary" />
            </div>
            <h2 className="font-heading font-semibold text-3xl mb-4">Paiement Réussi !</h2>
            <p className="text-muted-foreground mb-8">
              Merci pour votre commande. Vous recevrez un email de confirmation sous peu.
            </p>
            <Link
              to="/"
              className="bg-primary text-primary-foreground hover:bg-primary/90 h-12 px-8 rounded-full font-medium transition-all hover:scale-105 active:scale-95 shadow-lg shadow-primary/20 inline-flex items-center justify-center"
              data-testid="back-home-btn"
            >
              Retour à l'accueil
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="max-w-md mx-auto px-4 text-center" data-testid="payment-error">
        <div className="bg-white rounded-xl p-12">
          <h2 className="font-heading font-semibold text-3xl mb-4">Une erreur s'est produite</h2>
          <p className="text-muted-foreground mb-8">
            Nous n'avons pas pu vérifier votre paiement. Veuillez vérifier votre email ou nous contacter.
          </p>
          <Link
            to="/"
            className="bg-primary text-primary-foreground hover:bg-primary/90 h-12 px-8 rounded-full font-medium transition-all hover:scale-105 active:scale-95 shadow-lg shadow-primary/20 inline-flex items-center justify-center"
          >
            Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
};